import React, {useEffect, useState} from "react";
import './EdenredCallbackPage.scss'
import {useSearchParams} from "react-router-dom";
import logo from "../../Assets/Logos/bart.svg";
import axios from "axios";
import Loader from "../../Components/Loader/Loader";
import {useTranslation} from "react-i18next";

const EdenredCallbackPage:React.FC = () => {
    const {t} = useTranslation('edenredCallback')
    const [searchParams,] = useSearchParams();
    const [error, setError] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(true)
    useEffect(() => {
        const code = searchParams.get('code')
        const body = searchParams.get('state')
        axios.post(`${process.env.REACT_APP_BART_URL}/edenred/create-transaction/${code}`, JSON.parse(body ?? '{}'))
            .then(() => setError(false))
            .catch(() => setError(true))
            .finally(() => setLoading(false))

    }, [searchParams])
    if(loading) {
        return <Loader visible />
    }
    return (
        <div className="edenredCallbackPage__body">
            <img src={logo} alt="logo" className="edenredCallbackPage__body--logo"/>
            {
                error ? (
                    <>
                        <p className="edenredCallbackPage__body--successTxt">{t('errorTitle')}</p>
                        <p className="edenredCallbackPage__body--successSubtxt">{t('errorSubtitle')}</p>
                    </>
                ) : (
                    <>
                        <p className="edenredCallbackPage__body--successTxt">{t('successTitle')}</p>
                        <p className="edenredCallbackPage__body--successSubtxt">{t('successSubtitle')}</p>
                    </>
                )
            }
        </div>
    )
}

export default EdenredCallbackPage
